<template>
  <div v-if="ready" class="root">
    <AppHeader class="ai-header"/>
    <div class="ai-body">
      <div class="ai-swiper-pagination" :class="{'white-theme': !swiperActive}"></div>
      <swiper ref="pageSwiper" class="h-full" @slideChange="slideChangeHandler()" :options="swiperOptions">
        <swiper-slide class="h-full"><ModuleOne class="h-full"/></swiper-slide>
        <swiper-slide class="h-full"><ModuleTwo :isPlay="slide2MediaPlay" class="h-full"/></swiper-slide>
        <swiper-slide class="h-full"><ModuleThree class="h-full"/></swiper-slide>
        <swiper-slide class="h-full"><ModuleFour class="h-full"/></swiper-slide>
        <swiper-slide class="h-full">
          <ModuleFive class="h-m-40"/>
          <AppFooter class="ai-footer"/>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import AppHeader from './components/Header'
import AppFooter from './components/Footer'

import ModuleOne from './pages/Slide1'
import ModuleTwo from './pages/Slide2'
import ModuleThree from './pages/Slide3'
import ModuleFour from './pages/Slide4'
import ModuleFive from './pages/Slide5'

export default {
  components: {
    AppHeader,
    AppFooter,
    ModuleOne,
    ModuleTwo,
    ModuleThree,
    ModuleFour,
    ModuleFive
  },
  data () {
    const AppSelf = this
    return {
      slide2MediaPlay: false,
      swiperActive: 0,
      swiperOptions: {
        direction: 'vertical', // 竖直方向滚动
        // grabCursor: true, // 拖动时指针会变成抓手形状
        mousewheel: true, // 启动鼠标滚轮滚动
        pagination: {
          el: '.ai-swiper-pagination',
          clickable: true,
        },
        on: {
          init () {
            // console.log('----init----')
            AppSelf.swiperAnimate(this)
          },
          slideChangeTransitionEnd () {
            // console.log('----slidechange ----')
            AppSelf.swiperAnimate(this)
          }
        }
      },
      ready: false
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // 对于所有静态资源得加载
      this.ready = true
    },
    slideChangeHandler () {
      this.swiperActive = [1, 2, 3].includes(this.$refs.pageSwiper.swiper.activeIndex)
      if (this.$refs.pageSwiper.swiper.activeIndex === 1) {
        this.slide2MediaPlay = true
      } else {
        this.slide2MediaPlay = false
      }
    },
    swiperClearCache () {
      const slides = $('.ai-body .swiper-wrapper')[0].querySelectorAll(' .swiper-slide')
      slides.forEach(slide => {
        const allboxs = slide.querySelectorAll('.ai-animate')
        allboxs.forEach(box => {
          let classList = [$(box).attr('swiper-animate-effect')]
          if ($(box).attr('swiper-animate-delay')) {
            const delaySeconds = $(box).attr('swiper-animate-delay')
            classList.push(`delay-${delaySeconds}`)
          }
          if ($(box).attr('swiper-animate-speed')) {
            const speedSeconds = $(box).attr('swiper-animate-speed')
            classList.push(`speed-${speedSeconds}`)
          }
          box.style.visibility = 'hidden'
          box.classList.remove(...classList)
        })
      })
    },
    swiperAnimate (swiper) {
      this.swiperClearCache()
      const activeIdx = swiper.activeIndex
      const slides = $('.ai-body .swiper-wrapper .swiper-slide')
      const allboxs = slides[activeIdx].querySelectorAll('.ai-animate')
      allboxs.forEach(box => {
        let classList = ['animated', $(box).attr('swiper-animate-effect')]
        if ($(box).attr('swiper-animate-delay')) {
          const delaySeconds = $(box).attr('swiper-animate-delay')
          classList.push(`delay-${delaySeconds}`)
        }
        if ($(box).attr('swiper-animate-speed')) {
          const speedSeconds = $(box).attr('swiper-animate-speed')
          classList.push(`speed-${speedSeconds}`)
        }
        box.style.visibility = 'visible'
        box.classList.add(...classList)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~/src/style/_var";

.root {
  background: white;
  min-width: $app-width;
  height: 100%;
  $app-header-height: 60px;
  .ai-header {
    height: $app-header-height;
    background: white;
    border-bottom: 1px solid #e6e6e6;
  }
  .ai-footer {
    height: 40px;
    background: #56A5FF;
  }
  $cell-min-height: 885px;
  .ai-body {
    height: calc(100% - #{$app-header-height});
    $scroll-deadline: $cell-min-height + $app-header-height;
    @media screen and (max-height: $scroll-deadline){
      overflow-y: scroll;
    }
  }
  .ai-swiper-pagination {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    z-index: 99999;
    right: 55px;
    display: flex;
    flex-direction: column;
    /deep/ {
      .swiper-pagination-bullet {
        width: 3px;
        height: 25px;
        background:rgba(72,179,255,1);
        border-radius: 4px;
        opacity: 0.3;
        transition: opacity .5s ease, height .5s ease, background .5s ease;
        margin-bottom: 15px;
      }
      .swiper-pagination-bullet-active {
        background: #3299FF;
        height: 70px;
        opacity: 1;
      }
    }
    &.white-theme /deep/ {
      .swiper-pagination-bullet, .swiper-pagination-bullet-active {
        background: white;
      }
    }
  }
  .swiper-container {
    min-height: 885px;
    box-sizing: border-box;
    /deep/ * {
      box-sizing: inherit;
    }
    /deep/ {
      $delay-max: 3;
      @for $delay-duration from 0 through $delay-max {
        .delay-#{$delay-duration} {
          animation-delay: #{$delay-duration}s
        }
        @if $delay-duration <= 9 {
          @for $j from 1 to 10 {
            .delay-#{$delay-duration}_#{$j} {
              animation-delay: #{$delay-duration}#{'.'}#{$j}s
            }
          }
        } @else {
          .delay-#{$delay-duration}_5 {
            animation-delay: #{$delay-duration}#{'.'}#{'.5'}s
          }
        }
      }
      @for $speed-duration from 0 through $delay-max {
        .speed-#{$speed-duration} {
          animation-duration: #{$speed-duration}s
        }
        @if $speed-duration <= 9 {
          @for $j from 1 to 10 {
            .speed-#{$speed-duration}_#{$j} {
              animation-duration: #{$speed-duration}#{'.'}#{$j}s
            }
          }
        } @else {
          .speed-#{$speed-duration}_5 {
            animation-duration: #{$speed-duration}#{'.'}#{'.5'}s
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .root {
    min-width: 100%;
  }
}
@media (max-width: 767px) {
  .root {
    min-width: 100%;
    .ai-body {
      height: calc(100% - 40px);
    }
    .ai-swiper-pagination {
      // top: 50%;
      right: 10px;
      /deep/ {
        .swiper-pagination-bullet {
          margin-bottom: 15px;
        }
        .swiper-pagination-bullet-active {
          height: 45px;
        }
      }
    }
    .swiper-container {
      min-height: 100%;
      .swiper-slide {
        height: 100% !important;
      }
    }
    .h-m-40 {
      height: calc(100% - 60px);
    }
    .ai-footer {
      height: 60px;
      text-align: center
    }
  }
}
</style>
